/**
 * Tomaruba Guest API
 * Tomaruba Guest API
 *
 * OpenAPI spec version: 1.0.0
 * Contact: development@tomaruba.me
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 */

import ApiClient from '../ApiClient'
import Hotel from './Hotel'

/**
 * The InlineResponse20034 model module.
 * @module model/InlineResponse20034
 * @version 1.0.0
 */
export default class InlineResponse20034 {
  /**
   * Constructs a new <code>InlineResponse20034</code>.
   * @alias module:model/InlineResponse20034
   * @class
   */

  constructor() {}

  /**
   * Constructs a <code>InlineResponse20034</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/InlineResponse20034} obj Optional instance to populate.
   * @return {module:model/InlineResponse20034} The populated <code>InlineResponse20034</code> instance.
   */
  static constructFromObject(data, obj) {
    if (data) {
      obj = obj || new InlineResponse20034()

      if (data.hasOwnProperty('hotel')) {
        obj['hotel'] = Hotel.constructFromObject(data['hotel'])
      }
    }
    return obj
  }

  /**
   * @member {module:model/Hotel} hotel
   */
  hotel = undefined
}
